import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/site";
import { scrollToId } from "../lib/scroll";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-white/5 bg-night/85 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="relative mx-auto flex max-w-7xl items-center justify-center px-5 py-4 sm:px-8">
        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={go(l.id)}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-light text-cream/70 transition-colors duration-300 hover:text-goldlight"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => scrollToId("cara-bergabung")}
            data-testid="nav-cta-button"
            className="rounded-full bg-gold px-5 py-2.5 text-sm font-bold text-night transition-all duration-300 hover:scale-[1.05] hover:bg-goldlight"
          >
            Gandakan PROFIT
          </button>
        </div>
        <button
          className="absolute right-5 rounded-lg p-1.5 text-cream md:hidden sm:right-8"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-button"
          aria-label={open ? "Tutup menu" : "Buka menu"}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="mx-4 mb-4 flex flex-col gap-1 rounded-2xl border border-emerald/20 bg-forest p-4 text-center shadow-2xl md:hidden">
          {NAV_LINKS.map((l) => (
            <a
              key={l.id}
              href={`#${l.id}`}
              onClick={go(l.id)}
              data-testid={`mobile-link-${l.id}`}
              className="rounded-xl px-4 py-3 text-sm font-light text-cream/80 transition-colors hover:bg-white/5 hover:text-goldlight"
            >
              {l.label}
            </a>
          ))}
          <button
            onClick={() => { setOpen(false); scrollToId("cara-bergabung"); }}
            data-testid="mobile-nav-cta-button"
            className="mt-2 rounded-full bg-gold px-5 py-3 text-sm font-bold text-night"
          >
            Gandakan PROFIT
          </button>
        </div>
      )}
    </header>
  );
}
